import React from 'react';
import { ArrowDown, ArrowDownUp, ArrowUp, Plus } from 'react-bootstrap-icons';

import { NewsType } from '../../../../../Enum/Interest/NewsType';

interface Props {
    type: NewsType;
}

const ChangeIcon: React.FC<Props> = ({ type }: Props) => {
    switch (type) {
        case NewsType.LOWERED:
            return <ArrowDown className="groen mr-1" />;
        case NewsType.UPPED:
            return <ArrowUp className="rood mr-1" />;
        case NewsType.CHANGED:
            return <ArrowDownUp className="oranje mr-1" />;
        case NewsType.NEW:
            return <Plus className="blauw mr-1" />;
        default:
            return null;
    }
};

export default ChangeIcon;
